import "./ValidationMessage.scss";

const ValidationMessage = ({
    className = "",
    errorClassName = "",
    children,
    show,
    message = "Este campo es obligatorio",
}) => {
    return (
        <div className={`ValidationMessage ${className}`}>
            {children}
            {show && (
                <div className={`ValidationMessage__error ${errorClassName}`}>
                    <i className="pi pi-exclamation-circle ValidationMessage__icon"></i>
                    <span className="ValidationMessage__text">{message}</span>
                </div>
            )}
        </div>
    );
};

export default ValidationMessage;
